import { Config } from "../../../api/config";
export var ContractSaleOrderKeys = {
    InstallBase: "InstallBaseDetails",
    Paging: 'contractOrderPaging',
    ActiveContracts: 'activeContracts',
    NewContracts: 'newContracts',
    UpsertContractSaleOrder: 'upsertContractsaleOrder',
    GetServiceContractDetails: 'getServiceContractDetails',
    GetContractSaleOrder: 'getContractSaleOrder',
    GetInstallbase: 'CSOGetInstallbase',
    GetStatusCount: 'ContractSaleOrderStatusCount'
};
export var channelInstallBaseURL = "".concat(Config.baseURL, "Installbase/ChannelInstallbaseData");
export var CSOPagingAPI = "".concat(Config.baseURL, "ContractSaleOrder/PagingContractSaleOrder");
export var ActiveContractsURL = "".concat(Config.baseURL, "Installbase/FindActiveContract");
export var NewContractsURL = "".concat(Config.baseURL, "ServiceContract/GetNewContracts");
export var UsertContractSaleOrderURL = "".concat(Config.baseURL, "ContractSaleOrder/UpsertContractSaleOrder");
export var CancelContractSaleOrderURL = function (id) { return "".concat(Config.baseURL, "Order/").concat(id, "/CancelOrder"); };
export var GetContractSaleOrderURL = function (id) { return "".concat(Config.baseURL, "ContractSaleOrder/").concat(id, "/Get"); };
export var contractSaleOrderGetInstallBaseURL = function (id) {
    return "".concat(Config.baseURL, "Installbase/").concat(id, "/GetInstallbaseById");
};
export var GetServiceContractDetailsURL = function (id) { return "".concat(Config.baseURL, "ServiceContract/").concat(id, "/GetServiceContractDetails"); };
export var ContractSaleOrderStatusCoutURL = "".concat(Config.baseURL, "ContractSaleOrder/StatusCount");
